import React from 'react';
import SurfImageList from './SurfImageList'
import webapi from '../../../api/webapi';
import EmptyDiv from '../Footer/EmptyDIV';
import Loading from '../modal/Loading';


class SurfImageSelectBar extends React.Component{
    
    state = { item: '' };
    state = { modalshow: false };

    componentDidMount() {
        this.setState({item:''});   
    }

    async GetData() {
        this.setState({LoadingShow:true})
        await webapi.get('book/bookversionlistdata/'+this.state.item)
            .then(response => {
                this.setState({ BookVersionListData: response.data});
            })
        this.setState({LoadingShow:false})
    }

    async UpdateBookVersionList(){
        this.setState({LoadingShow:true})
        this.setState({ BookVersionListData : '' })
        await webapi.get('book/bookversionlist/'+this.state.SelectedBook+'/'+this.state.SelectedChapter)
            .then(response => {
                this.setState({ BookVersionList : response.data },()=>{});
            }) 

        if  (this.state.BookVersionList.length>0)
        {   
            this.setState({ item : this.state.BookVersionList[0].Code })
        }
        this.setState({LoadingShow:false})
    }

    componentDidUpdate() {
        if ((this.props.SelectedBook)&&(this.props.SelectedChapter)&&(this.props.SelectedChapter!==this.state.SelectedChapter))
        {
            this.setState({ SelectedBook : this.props.SelectedBook },()=>{});
            this.setState({ SelectedChapter : this.props.SelectedChapter },()=>{this.UpdateBookVersionList();});
        }
     }
     
    onSearchButtonClick = event =>{
        event.preventDefault();
        this.setState({ BookVersionListData : '' })
        this.GetData(); 
    }

    onTextChange = event=> {
        this.setState({ item : event.target.value });
        this.setState({ BookVersionListData : '' })
    }

    onTextKeyPress = event => {
        if ((event.nativeEvent.key === "Enter")&&(this.state.Item)) {
            event.preventDefault();
            this.onSearchButtonClick(event);
        }
    }

    render () {
        return (
            [
                <div className="SearchBar" style={{margin:'0px auto 0px auto',width:'100%'}}>
                    <form>
                        <div className="divSearch">
                            <div className="fullwidth_div">
                                <label style={{width:'calc(50% - 30px)',margin:'0px',marginRight: '25%',marginTop: '15px', float: 'right'}}>{this.props.Label}</label>
                                <select style={{width:'calc(50% - 30px)',direction:'inherit',margin:'0px 15px',marginRight: '25%',marginTop: '15px', float: 'right'}}
                                    id="item" 
                                    type="text" 
                                    className=""
                                    required="required" 
                                    value={this.state.item || ''} 
                                    onChange={this.onTextChange}
                                    onKeyPress={this.onTextKeyPress}
                                >  
                                    {   
                                        ((this.state.BookVersionList)&&(this.state.BookVersionList != null))
                                        ?
                                        (this.state.BookVersionList.map((BookVersion,i) =>
                                            {
                                                return  (
                                                    <option key={BookVersion.Code} value={BookVersion.Code}>{BookVersion.Title}</option> 
                                                )
                                            })
                                        )
                                        :
                                        <option value="-1">-</option>       
                                    }                
                                </select>
                            </div>
                            
                            <input className="submit_button" type="submit" value={this.props.pageData.length!==0 && this.props.pageData[0].F29901!== undefined?this.props.pageData[0].F29901:29901/*"جستجو"*/} onClick={this.onSearchButtonClick} />
                        </div>
                    </form>
                </div>
                ,
                (this.state.BookVersionListData && this.state.BookVersionListData.length>0)
                ?
                <SurfImageList BookVersionListData={this.state.BookVersionListData} />
                :
                <EmptyDiv />
                ,
                <Loading LoadingShow={this.state.LoadingShow} />
            ]
        );
    }
}

export default SurfImageSelectBar;